import { Box } from "@mui/material";
export default function DropShadowBox({ children, padding }) {
  return (
    <Box
      sx={{
        marginTop: "10px",
        padding: padding ?? "20px",
        alignItems: "center",
        borderRadius: "20px",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
      }}
    >
      {children}
    </Box>
  );
}
